import { Button, Col, Row, Tooltip } from 'antd';
import { useWorkorderDetailContext } from '../WorkorderDetailProvider';
import CustomTermsGenerateButton from './CustomTermsGenerateButton';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import ComplementCancel from './ComplementCancel';
import ComplementCloseFromDetail from './ComplementClose/ComplementCloseFromDetail';
import ComplementReopen from './ComplementReopen';
import ComplementWhatsappButton from './ComplementWhatsappButton';
import { useHistory } from 'react-router-dom';
import { WorkorderChecklistItemType } from '../../WorkorderChecklist/WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import WorkOrderReportsButton from './WorkOrderReportsButton';
import WorkOrderQRCodeButton from './WorkOrderQRCodeButton';
import ComplementDiffPriceButton from './ComplementDiffPriceButton';
import ButtonBack from '@/components/_common/ButtonBack';
import ReplicateComplementButton from './ReplicateComplementButton';
import usePageSearchHistory from '@/hooks/pageSearchHistory';
import ComplementMyBCS from './ComplementMyBCS';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import WorkOrderEtiquetteButton from './WorkOrderEtiquetteButton';
import WorkOrderReviewEtiquetteButton from './WorkOrderReviewEtiquetteButton';

interface Props {
  disabled: boolean;
}

const WorkOrderFooter: React.FC<Props> = ({ disabled }) => {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
    company: { data: company },
  } = useWorkorderDetailContext();

  const history = useHistory();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;

  const { getSearch } = usePageSearchHistory();
  const path = '/app/movements/workOrders';
  const pathWithSearch = path + getSearch(path);

  const printVisibleChecklist = !hasPermissions([
    Authorities.MOVIMENTATION_WORKORDER_VIEW_CHECKLIST,
  ]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24} md={12} lg={4} xxl={3}>
          <ButtonBack path={pathWithSearch} disabled={disabled} />
        </Col>

        <Col span={24} md={12} lg={8} xxl={6}>
          <WorkOrderReportsButton />
        </Col>

        <Col span={24} md={12} lg={8} xxl={6}>
          <CustomTermsGenerateButton />
        </Col>

        {(complement?.status === WorkOrderComplementStatus.Authorized ||
          complement?.status === WorkOrderComplementStatus.Open) && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <ReplicateComplementButton />
          </Col>
        )}

        <Col span={24} md={12} lg={4} xxl={3}>
          <ComplementWhatsappButton />
        </Col>

        {(complement?.status === WorkOrderComplementStatus.Cancelled ||
          complement?.status === WorkOrderComplementStatus.Closed) && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <ComplementReopen />
          </Col>
        )}

        {complement?.status !== WorkOrderComplementStatus.Cancelled && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <ComplementCancel />
          </Col>
        )}

        {complement?.status === WorkOrderComplementStatus.Authorized && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <ComplementCloseFromDetail />
          </Col>
        )}

        <Col span={24} md={12} lg={4} xxl={3}>
          <Tooltip
            title={
              !workorder?.vehicle?.id
                ? 'Não há veículo vinculado'
                : printVisibleChecklist
                ? 'Você não tem permissão para imprimir o checklist'
                : undefined
            }
          >
            <Button
              block
              disabled={!workorder?.vehicle?.id || printVisibleChecklist}
              onClick={() =>
                history.push(
                  `/app/movements/workorderChecklist/${complement?.id}/damages?checklistItemType=${WorkorderChecklistItemType.Workorder}&checklistItemId=${complement?.id}&workorderId=${workorder?.id}`,
                )
              }
            >
              Checklist
            </Button>
          </Tooltip>
        </Col>

        {complement?.status === WorkOrderComplementStatus.Authorized && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <WorkOrderQRCodeButton
              guid={complement.workOrderGuid}
              workOrder={workorder}
              complement={complement}
            />
          </Col>
        )}

        <Col span={24} md={12} lg={4} xxl={3}>
          <WorkOrderEtiquetteButton
            workOrder={workorder}
            complement={complement}
          />
        </Col>

        {isClosed && (
          <Col span={24} md={12} lg={4} xxl={3}>
            <WorkOrderReviewEtiquetteButton
              workOrder={workorder}
              complement={complement}
            />
          </Col>
        )}

        <ComplementDiffPriceButton />

        {!!company?.boschCompanyCode && (
          <Col span={24} md={12} lg={6} xxl={4}>
            <ComplementMyBCS />
          </Col>
        )}
      </Row>
    </>
  );
};

export default WorkOrderFooter;
